import { render, staticRenderFns } from "./CancelDispatchModal.vue?vue&type=template&id=53762bfe&scoped=true"
import script from "./CancelDispatchModal.vue?vue&type=script&lang=js"
export * from "./CancelDispatchModal.vue?vue&type=script&lang=js"
import style0 from "./CancelDispatchModal.vue?vue&type=style&index=0&id=53762bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53762bfe",
  null
  
)

export default component.exports